import React from "react";

import { faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import { faEyeSlash as faEyeSlashSolid } from "@fortawesome/pro-solid-svg-icons";
import { useFormContext } from "react-hook-form";
import { twJoin } from "tailwind-merge";

import { IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";
import {
  CommonSchemaEditRowProps,
  SchemaUI,
} from "src/schema/schemaMappingUtils";

const PiiDescriptionActive =
  "This field contains personally identifiable information and is made unavailable during backtesting and exports.";
const PiiDescriptionInactive =
  "Enable this toggle for fields that contain personally identifiable information, so that they can be made unavailable during backtesting and exports.";

export const SchemaSensitiveToggle: React.FC<CommonSchemaEditRowProps> = ({
  rowName,
  disabled,
}) => {
  const { getValues, setValue } = useFormContext<SchemaUI>();
  const value = getValues(`${rowName}.sensitive`);
  return (
    <Tooltip
      body={value ? PiiDescriptionActive : PiiDescriptionInactive}
      placement="right"
      title={
        value
          ? "This field is not stored in Decision History"
          : "Do not store in Decision History"
      }
      asChild
    >
      <div
        className={twJoin(
          disabled && "pointer-events-none",
          "flex items-center",
        )}
      >
        <IconButton
          isActive={value}
          disabled={disabled && !value}
          dataLoc={`schema-field-sensitive-${value}`}
          icon={value ? faEyeSlashSolid : faEyeSlash}
          size="xs"
          onClick={() => setValue(`${rowName}.sensitive`, !value)}
        />
      </div>
    </Tooltip>
  );
};
